const addIllustration = function(illustration, source) {
    for (let item of illustration) {
        let obj, type, properties;
        type = item.type;
        properties = item.properties;
        obj = source.append(type);
        for (let key in properties) {
            obj.attr(key, properties[key]);
        }
    }
};

export default {
    addIllustration
};
